import { useHiddenChannelsStore } from '~/stores/hiddenChannels'
import { useGroupsStore } from '~/stores/groups'
import { useNotificationSettingsStore } from '~/stores/notificationSettings'
import { useChannelMemberListStore } from '~/stores/channelMemberList'
import { useMessagesStore } from '~/stores/messages'
import { useFriendsStore } from '~/stores/friends'
import { useSubscriptionsStore } from '~/stores/subscriptions'
import { useAgentApprovalsStore } from '~/stores/agentApprovals'
import { useUserStore } from '~/stores/user'
import { resetBots } from '~/composables/useBots'
import { resetAgentMcpServers } from '~/composables/useAgentMcpServers'
import { resetAgentTasks } from '~/composables/useAgentTasks'
import { resetUserStatus } from '~/composables/useUserStatus'
import { resetLastPage } from '~/composables/useLastPage'
import { useMessageReply } from '~/composables/useMessageReply'
import { useMessageEditing } from '~/composables/useMessageEditing'
import { useMessageForward } from '~/composables/useMessageForward'
import { useMessageHighlight } from '~/composables/useMessageHighlight'
import { useInteractionModal } from '~/composables/useInteractionModal'
import { useUserProfileDialog } from '~/composables/useUserProfileDialog'

// Everything loaded for the signed-in account, dropped on logout so the next account (or the
// login screen) starts from nothing: every Pinia store, the module-level singletons that outlive
// pages (bots list, presence status, the "back to" page, half-done reply/edit/forward), and the
// per-account maps persisted in localStorage (last channel per group, last read message ids).
//
// Deliberately kept: the media cache (avatars, attachments on disk) and device/app settings -
// they are per-device, not per-account. Composer drafts are cleared by `useAuth().logout()`.
//
// When adding new per-account state that survives navigation, reset it here.
export function clearUserSession() {
  useGroupsStore().resetForLogout()
  useNotificationSettingsStore().resetForLogout()
  useHiddenChannelsStore().resetForLogout()
  useChannelMemberListStore().resetForLogout()
  useMessagesStore().resetForLogout()
  useFriendsStore().$reset()
  useSubscriptionsStore().clear()
  useAgentApprovalsStore().$reset()
  useUserStore().clearUser()

  resetBots()
  resetAgentMcpServers()
  resetAgentTasks()
  resetUserStatus()
  resetLastPage()
  useMessageReply().cancel()
  useMessageEditing().cancel()
  useMessageForward().cancel()
  useMessageHighlight().clear()
  useInteractionModal().cancel()
  useUserProfileDialog().close()
}
